import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { Uuid } from '@ftr/contracts/type/shared'
import { SelectableIdComponent } from '../selectable-id'
import { UrlSegment } from '../types'

@Component({
  selector: 'ftr-url-segments',
  templateUrl: './url-segments.component.html',
  styleUrl: './url-segments.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectableIdComponent],
})
export class UrlSegmentsComponent {
  readonly segments = input.required<UrlSegment[]>()

  readonly idSelected = output<Uuid>()
}
